import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import './Meetingticket.css'; // Custom styles

const Meetingticket = () => {
  const location = useLocation();
  const ticketRef = useRef();
  const hasDownloaded = useRef(false); // Flag to prevent multiple downloads
  const meetingData = location.state?.meetingData;

  // Build image URL
  const imageUrl = `${process.env.REACT_APP_API}/uploads/${meetingData?.photoPath}`;

  // Convert image URL to base64 (to avoid CORS issues in canvas)
  const getBase64ImageFromURL = async (url) => {
    const res = await fetch(url, { mode: 'cors' });
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  // Wait for image to fully load
  const waitForImageLoad = (imgElement, base64Src) => {
    return new Promise((resolve, reject) => {
      imgElement.onload = () => resolve();
      imgElement.onerror = () => reject(new Error('Image failed to load'));
      imgElement.src = base64Src;
    });
  };

  // PDF Download Logic
  const downloadPDF = async () => {
    try {
      const imgElement = ticketRef.current.querySelector('.ticket-photo img');

      if (imgElement && imgElement.src) {
        const base64 = await getBase64ImageFromURL(imgElement.src);
        await waitForImageLoad(imgElement, base64);

        const canvas = await html2canvas(ticketRef.current);
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(imgData, 'PNG', 0, 10, pdfWidth, pdfHeight);
        pdf.save('Meeting_Ticket.pdf');
      }
    } catch (error) {
      console.error('PDF generation failed:', error);
    }
  };

  // Auto download when component mounts (but only once)
  useEffect(() => {
    if (meetingData && !hasDownloaded.current) {
      hasDownloaded.current = true;
      setTimeout(() => {
        downloadPDF();
      }, 500);
    }
  }, [meetingData]);

  if (!meetingData) {
    return <div>No ticket data found</div>;
  }

  return (
    <div className="meeting-ticket-wrapper">
      <div className="ticket-body" ref={ticketRef} style={{ backgroundColor: 'beige' }}>
        <div className="ticket-header" style={{ backgroundColor: 'beige' }}>
          <img src="./logo.png" alt="Logo" className="logo" />
          <h2>🎫 Nalavariyam Meeting Pass</h2>
        </div>

        <div className="ticket-content">
          <div className="ticket-photo">
            <img src={imageUrl} alt="User" />
            <h6>Ticket No: <span>#00{meetingData.id}</span></h6>
          </div>

          <div className="ticket-info">
            <p><strong>👤 Name:</strong> {meetingData.full_name}</p>
            <p><strong>🧑‍💼 Designation:</strong> {meetingData.designation}</p>
            <p><strong>📞 Phone:</strong> {meetingData.phone}</p>
            <p><strong>📍 Location:</strong> சத்திரம் பேருந்து நிலையம்,<br />
              ஸ்ருதி ஸ்ரீ ஹால், 3/9 சங்கரன்பிள்ளை ரோடு,<br />
              [காலை மார்க்கெட் எதிரில்], திருச்சி-2</p>
            <p><strong>📅 Date:</strong> 5th August 2025</p>
            <p><strong>🕘 Time:</strong> 9:00 AM to 5:00 PM</p>
          </div>
        </div>
      </div>

      <div className="download-btn-wrapper">
        <button className="download-btn" onClick={downloadPDF}>
          Download Ticket
        </button>
      </div>
    </div>
  );
};

export default Meetingticket;
